import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import {
  OptionItemSpriteImageContainerStyles,
  OptionItemSpriteListStyles,
  OptionItemSpriteStyles,
} from './OptionItemSprite.styles';

export const OptionItemSpriteList: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OptionItemSpriteListStyles className={className}>
      {children}
    </OptionItemSpriteListStyles>
  );
};

export const OptionItemSprite: React.FC<{
  spriteSrc: string;
  alt: string;
  title: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
  theme?: 'violet';
  show: boolean;
  animate?: boolean;
}> = ({
  alt,
  spriteSrc,
  title,
  isSelected,
  onClick,
  TEST_ID,
  theme,
  show,
  animate,
}) => {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = animate && !shouldReduceMotion;

  if (canAnimate) {
    return (
      <AnimatePresence>
        {show && (
          <motion.div
            variants={{
              hidden: { opacity: 0, x: '100%' },
              visible: { opacity: 1, x: 0, scale: isSelected ? 1.02 : 0.98 },
            }}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <OptionItemSpriteStyles
              isSelected={isSelected}
              onClick={onClick}
              data-testid={TEST_ID}
              theme={theme}
            >
              <UiTypography
                className="option-item-sprite-title"
                variant="label-large"
              >
                {title}
              </UiTypography>
              <OptionItemSpriteImageContainerStyles>
                <img src={spriteSrc} alt={alt} />
              </OptionItemSpriteImageContainerStyles>
            </OptionItemSpriteStyles>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return (
    <OptionItemSpriteStyles
      isSelected={isSelected}
      onClick={onClick}
      data-testid={TEST_ID}
      theme={theme}
    >
      <UiTypography className="option-item-sprite-title" variant="label-large">
        {title}
      </UiTypography>
      <OptionItemSpriteImageContainerStyles>
        <img src={spriteSrc} alt={alt} />
      </OptionItemSpriteImageContainerStyles>
    </OptionItemSpriteStyles>
  );
};
